/* Scroll-reveal voor de homepage: secties en kaarten faden zachtjes
   omhoog zodra ze in beeld komen. Respecteert prefers-reduced-motion
   en doet niets in browsers zonder IntersectionObserver (dan is
   gewoon alles direct zichtbaar). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  if (!document.body.classList.contains('template-index')) return;

  var selectors = [
    '.hero__content',
    '.hero__media',
    '.section__head',
    '.usp-row .usp',
    '.buy-grid .buy-card',
    '.story__media',
    '.story__content',
    '.quotes .quote',
    '.cta-banner .page-width'
  ];

  var els = document.querySelectorAll(selectors.join(','));
  if (!els.length) return;

  /* Kleine vertraging per item binnen dezelfde rij (usp's, boeken, quotes)
     zodat ze na elkaar binnenkomen in plaats van allemaal tegelijk. */
  var groups = [];
  els.forEach(function (el) {
    el.classList.add('reveal');
    var parent = el.parentNode;
    var group = null;
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].parent === parent) { group = groups[i]; break; }
    }
    if (!group) { group = { parent: parent, count: 0 }; groups.push(group); }
    el.style.transitionDelay = Math.min(group.count * 90, 450) + 'ms';
    group.count++;
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal--visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  els.forEach(function (el) { io.observe(el); });
})();
